import clsx from 'clsx';
import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { IconTile } from '@gitbook/spine-react';

import { IntegrationIconByName } from '../Integrations';

/**
 * Icon for a conversation source.
 */
export function ConversationSourceTileIcon(props: {
    source: api.ConversationSource;
    size?: number;
    className?: string;
}): React.ReactElement {
    const { source, size, className } = props;
    return (
        <IconTile
            className={clsx('flex flex-shrink-0 items-center justify-center text-muted', className)}
            size={size}
        >
            <ConversationSourceIcon source={source} className="size-[90%]" />
        </IconTile>
    );
}

/**
 * Icon for a conversation source.
 */
export function ConversationSourceIcon(props: {
    source: api.ConversationSource;
    className: string;
}): React.ReactElement {
    const { source, className } = props;

    if (source.startsWith('integration:')) {
        const integrationName = source.replace('integration:', '');
        return (
            <div className={clsx('flex flex-shrink-0 items-center justify-center', className)}>
                <IntegrationIconByName integrationName={integrationName} className="size-full" />
            </div>
        );
    }

    if (source === 'email') {
        return <Icon.Email className={clsx('flex-shrink-0', className)} />;
    }

    return <Icon.OpenAPI className={clsx('flex-shrink-0', className)} />;
}
